import { PaymentIntegrationsActionType } from './actions';

// Adapted from Payments API via Argo API
export enum ProviderStripeStatus {
  /** Client does not yet know the status */
  FETCHING = 'fetching',
  /** Account onboarding has not been initiated yet */
  NOT_CONNECTED = 'not_connected',
  /** Account onboarding has not been completed, cannot perform charges yet */
  PENDING = 'pending',
  /** User has completed account onboarding, but a backend process is pending so they can't perform charges yet */
  PROCESSING = 'processing',
  /** Account approved and ready to perform charges */
  ACTIVE = 'active',
  /** Account has been rejected or disabled by provider */
  INACTIVE = 'inactive',
  /** Additional information needs to be provided, account could be disabled soon */
  DUE = 'due',
}

export interface StripeState {
  status: ProviderStripeStatus;
  accountEmail: string | null;
}

export interface PaymentIntegrationsState {
  stripe: StripeState;
}

export interface SetStripeStatusAction {
  type: PaymentIntegrationsActionType.setStripeStatus;
  payload: ProviderStripeStatus;
}

export interface SetStripeAccountEmailAction {
  type: PaymentIntegrationsActionType.setStripeAccountEmail;
  payload: string | null;
}

export type PaymentIntegrationsAction =
  | SetStripeStatusAction
  | SetStripeAccountEmailAction;
